module.exports = __webpack_public_path__ + "assets/img/mecha-detail-btn-99627b88.png";